import { z } from 'zod';
import { arrayToNonEmptyArray } from './array-to-non-empty-array';
import { BdmTreatment } from '@prisma/client';

export const bdmTreatmentZodEnum = () =>
  z
    .enum(arrayToNonEmptyArray(Object.values(BdmTreatment)))
    .transform(
      (value) =>
        BdmTreatment[value as keyof typeof BdmTreatment] as BdmTreatment,
    );
